import { IonContent } from '@ionic/react';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  DominateInputWithOptions,
  OptionType,
} from '@/pages/Onboarding/Layouts/OwnAI_Dominate/components/DominateInputWithOptions';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';
import { LayoutDataType } from '../../types';

import { PageStyles } from './Name.styles';

const options = [
  { id: '1', value: 'Pet', label: 'Pet' },
  { id: '2', value: 'Toy', label: 'Toy' },
  { id: '3', value: 'Darling', label: 'Darling' },
  { id: '4', value: 'Nothing', label: 'Nothing' },
];

export const ScreenName: React.FC = () => {
  const { refreshUser, user } = useAccount();
  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();

  const savedValue = form.watch('name') || '';
  const [inputValue, setInputValue] = useState<string>(savedValue);

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Domination Name',
      });
    }
  }, [user]);

  const handleInputChange = (value: string) => {
    setInputValue(value);
  };

  const handleSelect = (option: OptionType) => {
    setInputValue(option.label);
  };

  const handleNextStep = (): void => {
    if (inputValue.trim()) {
      userService
        .createOrUpdate({
          name: inputValue,
          onboarding_data: {
            name: inputValue,
          },
        })
        .then(() => {
          refreshUser();
        });

      form.setValue('name', inputValue);

      wizard.nextStep();
    }
  };

  const showContinueButton = inputValue.trim() !== '';

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation />
      <OwnAiTitle>
        What does she call you?
        <br />
        Your new role begins with a name.
      </OwnAiTitle>
      <IonContent>
        <DominateInputWithOptions
          options={options}
          value={inputValue}
          onChange={handleInputChange}
          onSelect={handleSelect}
        />
      </IonContent>

      {showContinueButton && (
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
        />
      )}
    </PageStyles>
  );
};
